const getEmployeeKey = (employee) => {
    return employee.userId === 0 ? `${employee.officeId}_${employee.titleId}_${employee.assignmentId}` : `${employee.userId}`;
}

export default getEmployeeKey;
